import { SearchContextData } from '../search-context-data';
import { SourceSettings } from './source-settings';

export interface SearchRequest<Settings extends SourceSettings> extends SearchContextData {
  sourceSettings: Settings;
  clientSearchId: string;
}
